/**
 *
 * @description Will return a JSON parsed object from localStorage with a given key
 * @param {string} key localStorage key
 * @returns JSON parsed object of what is in localStorage
 */
export const getObjectFromStorage = key => {
	return JSON.parse(localStorage.getItem(key));
};
